
import { safeHash, disposeSafe, getEnumerator, comparePrimitives, max, compare, min, createAtom, defaultOf, equals } from "../fable_modules/fable-library-js.5.13.0/Util.js";
import { BoundingBox__Centre, BoundingBox, ComponentType, XYPos } from "../Common/CommonTypes.js";
import { contains, tryFind as tryFind_1, cons, allPairs, concat, max as max_2, ofArray, map as map_4, reduce, tail, head, isEmpty, fold, collect, length as length_1, singleton, empty } from "../fable_modules/fable-library-js.5.13.0/List.js";
import { Record, Union } from "../fable_modules/fable-library-js.5.13.0/Types.js";
import { record_type, union_type, float64_type } from "../fable_modules/fable-library-js.5.13.0/Reflection.js";
import { DrawModelType_SheetT_MouseOn, DrawModelType_SheetT_symbols_, DrawModelType_SymbolT_Annotation, DrawModelType_SheetT_Model, DrawModelType_SheetT_canvasSize_, DrawModelType_SheetT_screenScrollPos_, DrawModelType_SheetT_lastMousePos_, DrawModelType_SheetT_lastMousePosForSnap_, DrawModelType_SheetT_scrollingLastMousePos_, DrawModelType_SheetT_pos_, DrawModelType_SheetT_symbol_, DrawModelType_SheetT_wire_, DrawModelType_SheetT_ArrayDirection, DrawModelType_SymbolT_Msg, DrawModelType_BusWireT_Model, DrawModelType_SheetT_Msg, DrawModelType_BusWireT_Msg } from "../Model/DrawModelType.js";
import { Msg } from "../Model/ModelType.js";
import { findDeletedPorts } from "./SymbolPortHelpers.js";
import { dbg } from "../Shared/Log.js";
import { getClickedWire, calculateBusWidths } from "./BusWireUpdate.js";
import { updateWireSegmentJumpsAndSeparations, routeAndSeparateSymbolWires } from "./BusWireSeparate.js";
import { deleteWiresWithPort } from "./BusWireUpdateHelpers.js";
import { extractComponents, ChangeSplitN, ChangeMergeN, ChangeGate, extractComponent, generateLabel } from "./SymbolUpdate.js";
import { extractConnection, extractConnections } from "./BusWire.js";
import { isEmpty as isEmpty_1, tryPick, tryFindKey, filter, toList as toList_1, find, tryFind, containsKey } from "../fable_modules/fable-library-js.5.13.0/Map.js";
import { FSharpSet_op_Subtraction, FSharpSet_op_Addition, toList, ofList } from "../fable_modules/fable-library-js.5.13.0/Set.js";
import { max as max_1, min as min_1 } from "../fable_modules/fable-library-js.5.13.0/Double.js";
import { toArray, defaultArg } from "../fable_modules/fable-library-js.5.13.0/Option.js";
import { moveSymbols, moveWires, copiedSymbolsInPasteOrder } from "./BlockHelpers.js";
import { getPortLocations, calcLabelBoundingBox } from "./Symbol.js";
import { MapModule_ValuesA } from "../Common/EEExtensions.js";
import { item, tryFindIndex, equalsWith, map as map_5 } from "../fable_modules/fable-library-js.5.13.0/Array.js";
import { Optic_Get, Optic_Get_op_HatDot_Z146BA564, Optic_Set, Optic_Set_op_HatEquals_Z147477F8, Compose_Lens, Compose_Lens_op_GreaterMinusGreater_Z15C92E89, Optic_Map, Optic_Map_op_HatPercent_Z1462312A } from "../Common/Optics.js";
import { boxesIntersect } from "../Common/DrawHelpers.js";
import { toList as toList_2 } from "../fable_modules/fable-library-js.5.13.0/Seq.js";
import { rangeDouble } from "../fable_modules/fable-library-js.5.13.0/Range.js";
import { getCustomSymCorners, translatePoints } from "./SymbolHelpers.js";

/**
 * return X=CanvasDiv.scrollLeft, Y= canvasDiv.scrollTop
 */
export function getScrollProps() {
    const el = document.getElementById("Canvas");
    if (equals(el, defaultOf())) {
        return undefined;
    }
    else {
        return new XYPos(el.scrollLeft, el.scrollTop);
    }
}

export function putScrollProps(props) {
    const el = document.getElementById("Canvas");
    if (!equals(el, defaultOf())) {
        el.scrollTop = props.Y;
        el.scrollLeft = props.X;
        return el;
    }
    else {
        return undefined;
    }
}

export let recentProgrammaticScrollPos = createAtom(empty());

export let scrollSequence = createAtom(0);

export let viewIsAfterUpdateScroll = createAtom(false);

export const Constants_maxUndoListSize = 50;

export const Constants_symbolSnapLimit = 7;

export const Constants_segmentSnapLimit = 7;

export const Constants_gridSize = 30;

export const Constants_defaultCanvasSize = 3500;

export const Constants_wireBoundingBoxSize = 2;

export const Constants_maxMagnification = 2;

export const Constants_minMagnification = 0.1;

export const Constants_zoomIncrement = 1.2;

export const Constants_fineZoomIncrement = 1.05;

export const Constants_fineZoomWheelStep = 30;

export const Constants_pinchZoomSensitivity = 0.007;

export const Constants_maxZoomFactorPerWheelEvent = 1.3;

export const Constants_boxAspectRatio = 2;

export const Constants_sheetMenuId = "SheetMenuDropdown";

export const Constants_maxFitAspectRatio = 3;

export const Constants_arrayGapFraction = 0.2;

export const Constants_arrayScreenFraction = 0.5;

export const Constants_arrayAspectWarning = 3;

export const Constants_boxParameters = {
    BoxMarginFraction: 0.1,
    BoxMin: 30,
    BoxOfEmptyCircuit: new XYPos(100, 100),
    CanvasBorder: 0.5,
    CanvasExtensionFraction: 0.1,
};

export class WheelZoom extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["PinchZoom", "PhysicalWheelZoom"];
    }
}

export function WheelZoom_$reflection() {
    return union_type("Sheet.WheelZoom", [], WheelZoom, () => [[["Item", float64_type]], [["Item", float64_type]]]);
}

function normalizedWheelDelta(deltaMode, deltaY) {
    switch (deltaMode) {
        case 1:
            return deltaY * 16;
        case 2:
            return deltaY * 800;
        default:
            return deltaY;
    }
}

function clamp(minValue, maxValue, value) {
    return min((x_1, y_1) => (compare(x_1, y_1) | 0), maxValue, max((x, y) => (compare(x, y) | 0), minValue, value));
}

/**
 * Classify a modified wheel event and calculate its zoom factor without touching the DOM.
 */
export function wheelZoom(deltaMode, deltaY, isZoomGesture, physicalModifierHeld) {
    let arg1__2;
    if (!isZoomGesture) {
        return undefined;
    }
    else {
        const delta = normalizedWheelDelta(deltaMode, deltaY);
        let bound;
        const minValue = 1 / Constants_maxZoomFactorPerWheelEvent;
        bound = ((value) => clamp(minValue, Constants_maxZoomFactorPerWheelEvent, value));
        if (physicalModifierHeld) {
            return new WheelZoom(/* PhysicalWheelZoom */ 1, [bound((arg1__2 = (-delta / Constants_fineZoomWheelStep), Math.pow(Constants_fineZoomIncrement, arg1__2)))]);
        }
        else {
            return new WheelZoom(/* PinchZoom */ 0, [bound(Math.exp(-delta * Constants_pinchZoomSensitivity))]);
        }
    }
}

/**
 * Calculate the scroll position that keeps a sheet point at the centre of the viewport.
 */
export function zoomCenteredScrollPosition(oldScreenCentre, zoom, clientWidth, clientHeight) {
    return new XYPos((oldScreenCentre.X * zoom) - (clientWidth / 2), (oldScreenCentre.Y * zoom) - (clientHeight / 2));
}

export function centreOfCanvas(model) {
    const dim = model.CanvasSize / 2;
    return new XYPos(dim, dim);
}

/**
 * Creates a command to Symbol
 */
export function symbolCmd(msg) {
    return singleton((dispatch) => {
        dispatch(new Msg(/* Sheet */ 3, [new DrawModelType_SheetT_Msg(/* Wire */ 0, [new DrawModelType_BusWireT_Msg(/* Symbol */ 0, [msg])])]));
    });
}

/**
 * Creates a command to BusWire
 */
export function wireCmd(msg) {
    return singleton((dispatch) => {
        dispatch(new Msg(/* Sheet */ 3, [new DrawModelType_SheetT_Msg(/* Wire */ 0, [msg])]));
    });
}

export function sheetCmd(msg) {
    return singleton((dispatch) => {
        dispatch(new Msg(/* Sheet */ 3, [msg]));
    });
}

export function DrawModelType_SheetT_Model__Model_ChangeComponent(this$, dispatch, symModel, compId, compType) {
    let bind$0040;
    const delPorts = findDeletedPorts(this$.Wire.Symbol, compId, DrawModelType_SheetT_Model__Model_GetComponentById_72DDFA37(this$, compId), compType);
    dbg(8, `changing component to ${compType}, deleting ${length_1(delPorts)} ports`);
    const patternInput = calculateBusWidths(routeAndSeparateSymbolWires(deleteWiresWithPort(delPorts, (bind$0040 = this$.Wire, new DrawModelType_BusWireT_Model(symModel, bind$0040.Wires, bind$0040.CopiedWires, bind$0040.SelectedSegment, bind$0040.LastMousePos, bind$0040.ErrorWires, bind$0040.Notifications, bind$0040.Type, bind$0040.ArrowDisplay, bind$0040.SnapToNet))), compId));
    dispatch(new DrawModelType_SheetT_Msg(/* SetWireModel */ 1, [patternInput[0]]));
    const option_1 = patternInput[1];
    if (option_1 != null) {
        dispatch(new DrawModelType_SheetT_Msg(/* Wire */ 0, [option_1]));
    }
}

/**
 * Given a compType, return a label
 */
export function DrawModelType_SheetT_Model__Model_GenerateLabel_Z7A46B106(this$, compType) {
    return generateLabel(this$.Wire.Symbol, compType);
}

/**
 * Given a compId, return the corresponding component
 */
export function DrawModelType_SheetT_Model__Model_GetComponentById_72DDFA37(this$, compId) {
    return extractComponent(this$.Wire.Symbol, compId);
}

/**
 * Change the label of Component specified by compId to lbl
 */
export function DrawModelType_SheetT_Model__Model_ChangeLabel(this$, dispatch, compId, lbl) {
    dispatch(new DrawModelType_SheetT_Msg(/* Wire */ 0, [new DrawModelType_BusWireT_Msg(/* Symbol */ 0, [new DrawModelType_SymbolT_Msg(/* ChangeLabel */ 13, [compId, lbl])])]));
}

/**
 * Run Bus Width Inference check
 */
export function DrawModelType_SheetT_Model__Model_DoBusWidthInference_Z1E9EDA9D(this$, dispatch) {
    return dispatch(new DrawModelType_SheetT_Msg(/* Wire */ 0, [DrawModelType_BusWireT_Msg.BusWidths]));
}

/**
 * Given a compId and a width, update the width of the Component specified by compId
 */
export function DrawModelType_SheetT_Model__Model_ChangeWidth(this$, dispatch, compId, width) {
    dispatch(new DrawModelType_SheetT_Msg(/* Wire */ 0, [new DrawModelType_BusWireT_Msg(/* Symbol */ 0, [new DrawModelType_SymbolT_Msg(/* ChangeNumberOfBits */ 17, [compId, width])])]));
    DrawModelType_SheetT_Model__Model_DoBusWidthInference_Z1E9EDA9D(this$, dispatch);
}

/**
 * Given a compId and a width, update the width of the Component specified by compId
 */
export function DrawModelType_SheetT_Model__Model_ChangeScale(this$, dispatch, compId, newScale, whichScale) {
    dispatch(new DrawModelType_SheetT_Msg(/* Wire */ 0, [new DrawModelType_BusWireT_Msg(/* Symbol */ 0, [new DrawModelType_SymbolT_Msg(/* ChangeScale */ 21, [compId, newScale, whichScale])])]));
    dispatch(new DrawModelType_SheetT_Msg(/* Wire */ 0, [new DrawModelType_BusWireT_Msg(/* UpdateSymbolWires */ 8, [compId])]));
}

export function DrawModelType_SheetT_Model__Model_ChangeAdderComp(this$, dispatch, compId, newComp) {
    dispatch(new DrawModelType_SheetT_Msg(/* Wire */ 0, [new DrawModelType_BusWireT_Msg(/* Symbol */ 0, [new DrawModelType_SymbolT_Msg(/* ChangeAdderComponent */ 25, [compId, DrawModelType_SheetT_Model__Model_GetComponentById_72DDFA37(this$, compId), newComp])])]));
    dispatch(new DrawModelType_SheetT_Msg(/* Wire */ 0, [new DrawModelType_BusWireT_Msg(/* DeleteWiresWithPort */ 5, [findDeletedPorts(this$.Wire.Symbol, compId, DrawModelType_SheetT_Model__Model_GetComponentById_72DDFA37(this$, compId), newComp)])]));
    dispatch(new DrawModelType_SheetT_Msg(/* Wire */ 0, [new DrawModelType_BusWireT_Msg(/* UpdateSymbolWires */ 8, [compId])]));
}

export function DrawModelType_SheetT_Model__Model_ChangeCounterComp(this$, dispatch, compId, newComp) {
    dispatch(new DrawModelType_SheetT_Msg(/* Wire */ 0, [new DrawModelType_BusWireT_Msg(/* Symbol */ 0, [new DrawModelType_SymbolT_Msg(/* ChangeCounterComponent */ 27, [compId, DrawModelType_SheetT_Model__Model_GetComponentById_72DDFA37(this$, compId), newComp])])]));
    dispatch(new DrawModelType_SheetT_Msg(/* Wire */ 0, [new DrawModelType_BusWireT_Msg(/* DeleteWiresWithPort */ 5, [findDeletedPorts(this$.Wire.Symbol, compId, DrawModelType_SheetT_Model__Model_GetComponentById_72DDFA37(this$, compId), newComp)])]));
    dispatch(new DrawModelType_SheetT_Msg(/* Wire */ 0, [new DrawModelType_BusWireT_Msg(/* UpdateSymbolWires */ 8, [compId])]));
}

/**
 * Given a compId, update the ReversedInputs property of the Component specified by compId
 */
export function DrawModelType_SheetT_Model__Model_ChangeReversedInputs(this$, dispatch, compId) {
    dispatch(new DrawModelType_SheetT_Msg(/* Wire */ 0, [new DrawModelType_BusWireT_Msg(/* Symbol */ 0, [new DrawModelType_SymbolT_Msg(/* ChangeReversedInputs */ 24, [compId])])]));
    dispatch(new DrawModelType_SheetT_Msg(/* Wire */ 0, [new DrawModelType_BusWireT_Msg(/* UpdateSymbolWires */ 8, [compId])]));
    DrawModelType_SheetT_Model__Model_DoBusWidthInference_Z1E9EDA9D(this$, dispatch);
}

/**
 * Given a compId and the number in inputs, set the number of inputs for a gate
 */
export function DrawModelType_SheetT_Model__Model_ChangeGate(this$, dispatch, compId, gateType, n) {
    DrawModelType_SheetT_Model__Model_ChangeComponent(this$, dispatch, ChangeGate(compId, gateType, n, this$.Wire.Symbol), compId, new ComponentType(/* GateN */ 10, [gateType, n]));
}

/**
 * Given a compId, number of inputs
 */
export function DrawModelType_SheetT_Model__Model_ChangeMergeN(this$, dispatch, compId, numInputs) {
    DrawModelType_SheetT_Model__Model_ChangeComponent(this$, dispatch, ChangeMergeN(compId, numInputs, this$.Wire.Symbol), compId, new ComponentType(/* MergeN */ 29, [numInputs]));
}

/**
 * Given comId, number of inputs, widths and LSBs
 */
export function DrawModelType_SheetT_Model__Model_ChangeSplitN(this$, dispatch, compId, numInputs, widths, lsbs) {
    DrawModelType_SheetT_Model__Model_ChangeComponent(this$, dispatch, ChangeSplitN(compId, numInputs, widths, lsbs, this$.Wire.Symbol), compId, new ComponentType(/* SplitN */ 30, [numInputs, widths, lsbs]));
}

/**
 * Given a compId and a LSB, update the LSB of the Component specified by compId
 */
export function DrawModelType_SheetT_Model__Model_ChangeLSB(this$, dispatch, compId, lsb) {
    dispatch(new DrawModelType_SheetT_Msg(/* Wire */ 0, [new DrawModelType_BusWireT_Msg(/* Symbol */ 0, [new DrawModelType_SymbolT_Msg(/* ChangeLsb */ 18, [compId, lsb])])]));
}

export function DrawModelType_SheetT_Model__Model_ChangeInputValue(this$, dispatch, compId, newVal) {
    dispatch(new DrawModelType_SheetT_Msg(/* Wire */ 0, [new DrawModelType_BusWireT_Msg(/* Symbol */ 0, [new DrawModelType_SymbolT_Msg(/* ChangeInputValue */ 19, [compId, newVal])])]));
}

/**
 * Given a compId and a channel number, set which channel a join uses.
 */
export function DrawModelType_SheetT_Model__Model_ChangeJoinNum(this$, dispatch, compId, newNum) {
    dispatch(new DrawModelType_SheetT_Msg(/* Wire */ 0, [new DrawModelType_BusWireT_Msg(/* Symbol */ 0, [new DrawModelType_SymbolT_Msg(/* ChangeJoinNum */ 20, [compId, newNum])])]));
}

/**
 * Return Some string if Sheet / BusWire / Symbol has a notification, if there is none then return None
 */
export function DrawModelType_SheetT_Model__Model_get_GetNotifications(this$) {
    return this$.Wire.Notifications;
}

/**
 * Get the current canvas state in the form of (Component list * Connection list)
 */
export function DrawModelType_SheetT_Model__Model_GetCanvasState(this$) {
    return [extractComponents(this$.Wire.Symbol), extractConnections(this$.Wire)];
}

/**
 * Clears the Undo and Redo stack of Sheet
 */
export function DrawModelType_SheetT_Model__Model_FlushCommandStack_Z1E9EDA9D(this$, dispatch) {
    return dispatch(DrawModelType_SheetT_Msg.FlushCommandStack);
}

/**
 * Clears the canvas, removes all components and connections
 */
export function DrawModelType_SheetT_Model__Model_ClearCanvas_7D5C5FDA(this$, dispatch) {
    dispatch(DrawModelType_SheetT_Msg.ResetModel);
    dispatch(new DrawModelType_SheetT_Msg(/* Wire */ 0, [DrawModelType_BusWireT_Msg.ResetModel]));
    dispatch(new DrawModelType_SheetT_Msg(/* Wire */ 0, [new DrawModelType_BusWireT_Msg(/* Symbol */ 0, [DrawModelType_SymbolT_Msg.ResetModel])]));
}

/**
 * Returns a list of selected components
 */
export function DrawModelType_SheetT_Model__Model_get_GetSelectedComponents(this$) {
    return collect((compId) => {
        if (containsKey(compId, this$.Wire.Symbol.Symbols)) {
            return singleton(extractComponent(this$.Wire.Symbol, compId));
        }
        else {
            return empty();
        }
    }, this$.SelectedComponents);
}

/**
 * Returns a list of selected connections
 */
export function DrawModelType_SheetT_Model__Model_get_GetSelectedConnections(this$) {
    return collect((connId) => {
        if (containsKey(connId, this$.Wire.Wires)) {
            return singleton(extractConnection(this$.Wire, connId));
        }
        else {
            return empty();
        }
    }, this$.SelectedWires);
}

/**
 * Returns a list of selected components and connections in the form of (Component list * Connection list)
 */
export function DrawModelType_SheetT_Model__Model_get_GetSelectedCanvasState(this$) {
    return [DrawModelType_SheetT_Model__Model_get_GetSelectedComponents(this$), DrawModelType_SheetT_Model__Model_get_GetSelectedConnections(this$)];
}

/**
 * Given a list of connIds, select those connections
 */
export function DrawModelType_SheetT_Model__Model_SelectConnections(this$, dispatch, on, connIds) {
    return dispatch(new DrawModelType_SheetT_Msg(/* UpdateSelectedWires */ 23, [connIds, on]));
}

/**
 * Update the memory of component
 */
export function DrawModelType_SheetT_Model__Model_WriteMemoryType(this$, dispatch, compId, mem) {
    return dispatch(new DrawModelType_SheetT_Msg(/* Wire */ 0, [new DrawModelType_BusWireT_Msg(/* Symbol */ 0, [new DrawModelType_SymbolT_Msg(/* WriteMemoryType */ 31, [compId, mem])])]));
}

/**
 * Update the memory of component
 */
export function DrawModelType_SheetT_Model__Model_UpdateMemory(this$, dispatch, compId, mem) {
    return dispatch(new DrawModelType_SheetT_Msg(/* Wire */ 0, [new DrawModelType_BusWireT_Msg(/* Symbol */ 0, [new DrawModelType_SymbolT_Msg(/* UpdateMemory */ 32, [compId, mem])])]));
}

/**
 * Update the memory of component specified by connId at location addr with data value
 */
export function DrawModelType_SheetT_Model__Model_WriteMemoryLine(this$, dispatch, connId, addr, value) {
    return dispatch(new DrawModelType_SheetT_Msg(/* Wire */ 0, [new DrawModelType_BusWireT_Msg(/* Symbol */ 0, [new DrawModelType_SymbolT_Msg(/* WriteMemoryLine */ 30, [connId, addr, value])])]));
}

export function symDiff(lst1, lst2) {
    const a = ofList(lst1, {
        Compare: (x, y) => (compare(x, y) | 0),
    });
    const b = ofList(lst2, {
        Compare: (x_1, y_1) => (compare(x_1, y_1) | 0),
    });
    return toList(FSharpSet_op_Addition(FSharpSet_op_Subtraction(a, b), FSharpSet_op_Subtraction(b, a)));
}

/**
 * return screen edge coords if possible
 */
export function getScreenEdgeCoords(model) {
    const canvas = document.getElementById("Canvas");
    if (equals(canvas, defaultOf())) {
        return undefined;
    }
    else {
        const wholeApp = document.getElementById("WholeApp");
        const rightSelection = document.getElementById("RightSelection");
        const topMenu = document.getElementById("TopMenu");
        const left = model.ScreenScrollPos;
        const right = new XYPos(canvas.scrollLeft, canvas.scrollTop);
        new XYPos(left.X - right.X, left.Y - right.Y);
        const leftScreenEdge = canvas.scrollLeft;
        const rightScreenEdge = (leftScreenEdge + wholeApp.clientWidth) - rightSelection.offsetWidth;
        const topScreenEdge = canvas.scrollTop;
        return {
            Bottom: (topScreenEdge + rightSelection.offsetHeight) - topMenu.clientHeight,
            Left: leftScreenEdge,
            Right: rightScreenEdge,
            Top: topScreenEdge,
        };
    }
}

export function centreOfScreen(model) {
    let edge;
    const option_1 = getScreenEdgeCoords(model);
    if (option_1 != null) {
        return (edge = option_1, new XYPos((edge.Left + edge.Right) / (2 * model.Zoom), (edge.Top + edge.Bottom) / (2 * model.Zoom)));
    }
    else {
        return undefined;
    }
}

/**
 * helper used inside Map.tryFind hence the unused parameter
 * returns true if pos is insoie boundingbox
 */
export function insideBox(pos, boundingBox) {
    const yBox = boundingBox.TopLeft.Y;
    const xBox = boundingBox.TopLeft.X;
    if (((pos.X >= xBox) && (pos.X <= (xBox + boundingBox.W))) && (pos.Y >= yBox)) {
        return pos.Y <= (yBox + boundingBox.H);
    }
    else {
        return false;
    }
}

/**
 * return a BB equivalent to input but with (X,Y) = LH Top coord, (X+W,Y+H) = RH bottom coord
 * note that LH Top is lower end of the two screen coordinates
 */
export function standardiseBox(box) {
    return new BoundingBox(new XYPos(min_1(box.TopLeft.X, box.TopLeft.X + box.W), min_1(box.TopLeft.Y, box.TopLeft.Y + box.H)), Math.abs(box.W), Math.abs(box.H));
}

export function transformScreenToPos(screenPos, scrollPos, mag) {
    return new XYPos((screenPos.X + scrollPos.X) / mag, (screenPos.Y + scrollPos.Y) / mag);
}

/**
 * calculates the smallest bounding box that contains two BBs, in form with W,H > 0
 */
export function boxUnion(box, box$0027) {
    const maxX = max_1(box.TopLeft.X + box.W, box$0027.TopLeft.X + box$0027.W);
    const maxY = max_1(box.TopLeft.Y + box.H, box$0027.TopLeft.Y + box$0027.H);
    const minX = min_1(box.TopLeft.X, box$0027.TopLeft.X);
    const minY = min_1(box.TopLeft.Y, box$0027.TopLeft.Y);
    return new BoundingBox(new XYPos(minX, minY), maxX - minX, maxY - minY);
}

/**
 * Returns the smallest BB containing box and point.
 * Could be made more efficient
 */
export function boxPointUnion(box, point) {
    return boxUnion(box, new BoundingBox(point, 0, 0));
}

export function symbolToBB(centresOnly, symbol) {
    let left, right;
    let patternInput_1;
    const sym = symbol;
    const comp = sym.Component;
    const matchValue = defaultArg(sym.HScale, 1);
    const vS = defaultArg(sym.VScale, 1);
    const hS = matchValue;
    const matchValue_2 = sym.STransform.Rotation;
    switch (matchValue_2.tag) {
        case 1:
        case 3: {
            patternInput_1 = [comp.W * hS, comp.H * vS];
            break;
        }
        default:
            patternInput_1 = [comp.H * vS, comp.W * hS];
    }
    const w = patternInput_1[1];
    const h = patternInput_1[0];
    if (centresOnly) {
        return new BoundingBox((left = symbol.Pos, (right = (new XYPos(w / 2, h / 2)), new XYPos(left.X + right.X, left.Y + right.Y))), 0, 0);
    }
    else {
        return new BoundingBox(symbol.Pos, w, h);
    }
}

export function symbolToCentre(symbol) {
    let left, right;
    let patternInput_1;
    const sym = symbol;
    const comp = sym.Component;
    const matchValue = defaultArg(sym.HScale, 1);
    const vS = defaultArg(sym.VScale, 1);
    const hS = matchValue;
    const matchValue_2 = sym.STransform.Rotation;
    switch (matchValue_2.tag) {
        case 1:
        case 3: {
            patternInput_1 = [comp.W * hS, comp.H * vS];
            break;
        }
        default:
            patternInput_1 = [comp.H * vS, comp.W * hS];
    }
    return new BoundingBox((left = symbol.Pos, (right = (new XYPos(patternInput_1[1] / 2, patternInput_1[0] / 2)), new XYPos(left.X + right.X, left.Y + right.Y))), 0.1, 0.1);
}

/**
 * Returns the smallest BB that contains all segments
 * of wire.
 */
export function wireToBB(wire) {
    const wire_2 = wire;
    return fold((tupledArg, seg) => {
        const currState = tupledArg[0];
        const currPos = tupledArg[1];
        const currOrientation = tupledArg[2];
        const nextOrientation = (currOrientation === "vertical") ? "horizontal" : "vertical";
        if (Math.abs(seg.Length) < 1E-07) {
            return [currState, currPos, nextOrientation];
        }
        else {
            let nextPos;
            const position = currPos;
            const length = seg.Length;
            nextPos = ((currOrientation === "vertical") ? (new XYPos(position.X, position.Y + length)) : (new XYPos(position.X + length, position.Y)));
            return [boxPointUnion(currState, nextPos), nextPos, nextOrientation];
        }
    }, [new BoundingBox(wire.StartPos, 0, 0), wire_2.StartPos, wire_2.InitialOrientation], wire_2.Segments)[0];
}

export function symbolBBUnion(centresOnly, symbols) {
    if (!isEmpty(symbols)) {
        return fold((box, sym_1) => {
            if (centresOnly) {
                return boxUnion(symbolToBB(centresOnly, sym_1), box);
            }
            else {
                return boxUnion(box, boxUnion(symbolToBB(centresOnly, sym_1), sym_1.LabelBoundingBox));
            }
        }, symbolToBB(centresOnly, head(symbols)), tail(symbols));
    }
    else {
        return undefined;
    }
}

/**
 * The bounding box of what is on the clipboard, or None when nothing has been copied.
 * 
 * Labels are included, and have to be: a label sits below its symbol, so a fragment measured
 * without them leaves a gap that the label of one copy hangs into the next through. A single
 * copied component is the case that shows it - symbolBBUnion takes the first symbol's box
 * without its label, which for one symbol is the whole answer.
 * 
 * Recalculated rather than read off the symbol, as symbolWireBBUnion does: the stored box is only
 * as fresh as whatever last set it, and these symbols were put aside when they were copied.
 */
export function copiedFragmentBox(model) {
    const matchValue = copiedSymbolsInPasteOrder(model.Wire.Symbol);
    if (isEmpty(matchValue)) {
        return undefined;
    }
    else {
        return reduce(boxUnion, map_4((sym) => boxUnion(symbolToBB(false, sym), calcLabelBoundingBox(sym).LabelBoundingBox), matchValue));
    }
}

/**
 * The size of `box` along the direction an array runs.
 */
export function alongArray(dir, box) {
    if (dir.tag === 1) {
        return box.W;
    }
    else {
        return box.H;
    }
}

/**
 * From one copy of `box` to the next: the fragment's own size along the array, plus a gap.
 */
export function arrayStep(dir, box) {
    return alongArray(dir, box) * (1 + Constants_arrayGapFraction);
}

/**
 * Where the `i`th copy of an array goes, relative to the first.
 */
export function arrayOffset(dir, box, i) {
    const d = arrayStep(dir, box) * i;
    if (dir.tag === 1) {
        return new XYPos(d, 0);
    }
    else {
        return new XYPos(0, d);
    }
}

/**
 * The bounding box `copies` copies of `box` occupy once arrayed.
 */
export function arrayBox(dir, copies, box) {
    const span = arrayStep(dir, box) * max_1(0, copies - 1);
    if (dir.tag === 1) {
        return new BoundingBox(box.TopLeft, box.W + span, box.H);
    }
    else {
        return new BoundingBox(box.TopLeft, box.W, box.H + span);
    }
}

/**
 * The most copies of `box` that fit on a canvas `canvasSize` square, which is the whole of what a
 * sheet has room for. Can be below 2, which means there is no array to paste at all.
 */
export function maxArrayCopies(dir, canvasSize, box) {
    const size = alongArray(dir, box);
    const g = Constants_arrayGapFraction;
    if (size <= 0) {
        return 0;
    }
    else {
        return ~~(((canvasSize / size) + g) / (1 + g)) | 0;
    }
}

/**
 * Whether arraying `box` this way runs it along its long axis, by more than
 * Constants.arrayAspectWarning. Copies then stack end to end into a strip, which is what the
 * dialog warns about rather than refuses: it is occasionally what is wanted.
 */
export function arrayIsAgainstShape(dir, box) {
    const patternInput = (dir.tag === 1) ? [box.W, box.H] : [box.H, box.W];
    const across = patternInput[1];
    if (across > 0) {
        return patternInput[0] > (across * Constants_arrayAspectWarning);
    }
    else {
        return false;
    }
}

/**
 * The direction a fragment of this shape should be arrayed in: across its short axis, so the
 * copies stack up beside each other. A square fragment goes vertically, which is the way a row of
 * repeated logic is normally built up.
 */
export function arrayDirectionFor(box) {
    if (box.H > box.W) {
        return DrawModelType_SheetT_ArrayDirection.ArrayHorizontal;
    }
    else {
        return DrawModelType_SheetT_ArrayDirection.ArrayVertical;
    }
}

/**
 * Returns the smallest BB that contains all symbols, labels, and wire segments.
 * For empty circuit a BB is returned in middle of viewable screen.
 */
export function symbolWireBBUnion(model) {
    let wiresBBA;
    const symbols = ofArray(MapModule_ValuesA(model.Wire.Symbol.Symbols));
    const symbolBB = symbolBBUnion(false, symbols);
    const labelsBB = map_4((sym) => calcLabelBoundingBox(sym).LabelBoundingBox, symbols);
    const _arg_1 = collect((_arg) => {
        if (_arg != null) {
            return singleton(_arg);
        }
        else {
            return empty();
        }
    }, ofArray([symbolBB, isEmpty(labelsBB) ? undefined : reduce(boxUnion, labelsBB), (wiresBBA = map_5(wireToBB, MapModule_ValuesA(model.Wire.Wires)), (!equalsWith(equals, wiresBBA, defaultOf()) && (wiresBBA.length === 0)) ? undefined : wiresBBA.reduce(boxUnion))]));
    if (!isEmpty(_arg_1)) {
        if (isEmpty(tail(_arg_1))) {
            return head(_arg_1);
        }
        else {
            return reduce(boxUnion, _arg_1);
        }
    }
    else {
        return new BoundingBox(defaultArg(centreOfScreen(model), new XYPos(0, 0)), 0, 0);
    }
}

export function moveCircuit(moveDelta, model) {
    return Optic_Map_op_HatPercent_Z1462312A(Optic_Map.Map$, DrawModelType_SheetT_wire_)((model_3) => updateWireSegmentJumpsAndSeparations(empty(), model_3))(Optic_Map_op_HatPercent_Z1462312A(Optic_Map.Map$, DrawModelType_SheetT_wire_)((model_2) => moveWires(moveDelta, model_2))(Optic_Map_op_HatPercent_Z1462312A(Optic_Map.Map$, DrawModelType_SheetT_symbol_)((model_1) => moveSymbols(moveDelta, model_1))(model)));
}

/**
 * The window a fit has to work with. Normally the whole drawing area; with the Sheet menu pinned
 * open over the left of it, what the menu leaves - which is what makes a pinned menu something to
 * work beside rather than something in the way. Everything a fit does follows from this, so
 * nothing below has to know the Sheet menu exists.
 * 
 * Inset is how far in from the drawing area's left edge the usable part starts. Magnification does
 * not care where the window begins, but the scroll does: it has to put the circuit past the menu
 * and then half way across the rest.
 */
export class FitWindow extends Record {
    constructor(Inset, Width, Height) {
        super();
        this.Inset = Inset;
        this.Width = Width;
        this.Height = Height;
    }
}

export function FitWindow_$reflection() {
    return record_type("Sheet.FitWindow", [], FitWindow, () => [["Inset", float64_type], ["Width", float64_type], ["Height", float64_type]]);
}

/**
 * Width of the drawing area's left edge the Sheet menu is over, and 0 when the menu is closed -
 * which is display:none, and so has no width. Measured rather than derived because it is a
 * rendered fact: it depends on the design's tree and on how much room the canvas gives it.
 */
export function openSheetMenuWidth() {
    const menu = document.getElementById(Constants_sheetMenuId);
    if (equals(menu, defaultOf())) {
        return 0;
    }
    else {
        return menu.offsetWidth;
    }
}

/**
 * How much of the left of a `width` by `height` drawing area a fit should leave to a menu
 * `menuWidth` wide: all of it, unless what is left over is a slot more than
 * Constants.maxFitAspectRatio times as tall as it is wide (or as wide as tall), where going round
 * the menu would shrink the circuit further than the menu ever hides it.
 */
export function fitInsetFor(menuWidth, width, height) {
    const clear = width - menuWidth;
    if ((((menuWidth > 0) && (clear > 0)) && (height > 0)) && (max_1(clear / height, height / clear) <= Constants_maxFitAspectRatio)) {
        return menuWidth;
    }
    else {
        return 0;
    }
}

/**
 * The window a fit should use, for the whole Issie model - which is what says whether the Sheet
 * menu is pinned. The draw block is handed this rather than working it out, because
 * Model.SheetMenuPinned is not draw block state: see SheetUpdate.update, which is given the whole
 * model for exactly this.
 * 
 * None when there is no canvas to measure, which is what the fit used to return None for.
 */
export function fitWindowFor(issieModel) {
    let edge, height, width, inset;
    const option_1 = getScreenEdgeCoords(issieModel.Sheet);
    if (option_1 != null) {
        return (edge = option_1, (height = (edge.Bottom - edge.Top), (width = (edge.Right - edge.Left), (inset = (issieModel.SheetMenuPinned ? fitInsetFor(openSheetMenuWidth(), width, height) : 0), new FitWindow(inset, width - inset, height)))));
    }
    else {
        return undefined;
    }
}

/**
 * The magnification that puts `box` in `win`, as large as the window and the zoom limit allow.
 */
export function magToFitBox(win, box) {
    return min_1(min_1(win.Width / box.W, win.Height / box.H), Constants_maxMagnification);
}

/**
 * get scroll and zoom paras to fit box all on screen centred and occupying as much of screen as possible
 */
export function getWindowParasToFitBox(win, box) {
    const mag = magToFitBox(win, box);
    return {
        MagToUse: mag,
        Scroll: new XYPos(((box.TopLeft.X + (box.W / 2)) * mag) - (win.Inset + (win.Width / 2)), ((box.TopLeft.Y + (box.H / 2)) * mag) - (win.Height / 2)),
    };
}

export function addBoxMargin(fractionalMargin, absoluteMargin, box) {
    let left, right;
    const boxMargin = max_1(absoluteMargin, max_1(box.W, box.H) * fractionalMargin);
    return new BoundingBox((left = box.TopLeft, (right = (new XYPos(boxMargin, boxMargin)), new XYPos(left.X - right.X, left.Y - right.Y))), box.W + (boxMargin * 2), box.H + (boxMargin * 2));
}

/**
 * Check that canvas is large enough to have space all round the visible area.
 * If not, then change model by moving circuit on canvas and/or extending canvas.
 * Keep components in same visible position during this process.
 * returns new model with all positions updated if need be.
 */
export function ensureCanvasExtendsBeyondScreen(model) {
    let left_1, right_1, pos, scaleFactor;
    const boxParas = Constants_boxParameters;
    getScreenEdgeCoords(model);
    const box_1 = addBoxMargin(boxParas.CanvasExtensionFraction, boxParas.BoxMin, symbolWireBBUnion(model));
    const quant = boxParas.CanvasExtensionFraction * min_1(box_1.H, box_1.W);
    const newSize = max_1(model.CanvasSize, max_2(map_4((x) => (x + (4 * quant)), ofArray([box_1.H, box_1.W])), {
        Compare: (x_1, y) => (comparePrimitives(x_1, y) | 0),
    }));
    let bottomRight;
    const left = box_1.TopLeft;
    const right = new XYPos(box_1.W, box_1.H);
    bottomRight = (new XYPos(left.X + right.X, left.Y + right.Y));
    const size = model.CanvasSize;
    const xIsOk = (box_1.TopLeft.X > 0) && (bottomRight.X < size);
    const yIsOk = (box_1.TopLeft.Y > 0) && (bottomRight.Y < size);
    if (xIsOk && yIsOk) {
        return model;
    }
    else {
        let circuitMove;
        const centre = BoundingBox__Centre(box_1);
        circuitMove = (new XYPos(xIsOk ? 0 : ((newSize / 2) - centre.X), yIsOk ? 0 : ((newSize / 2) - centre.Y)));
        scrollSequence(scrollSequence() + 1);
        putScrollProps((left_1 = model.ScreenScrollPos, (right_1 = ((pos = circuitMove, (scaleFactor = model.Zoom, new XYPos(pos.X * scaleFactor, pos.Y * scaleFactor)))), new XYPos(left_1.X + right_1.X, left_1.Y + right_1.Y))));
        const posDelta = (y_1) => {
            const left_2 = circuitMove;
            const right_2 = y_1;
            return new XYPos(left_2.X + right_2.X, left_2.Y + right_2.Y);
        };
        let posScreenDelta;
        let x_2;
        const pos_1 = circuitMove;
        const scaleFactor_1 = model.Zoom;
        x_2 = (new XYPos(pos_1.X * scaleFactor_1, pos_1.Y * scaleFactor_1));
        posScreenDelta = ((y_2) => {
            const left_3 = x_2;
            const right_3 = y_2;
            return new XYPos(left_3.X + right_3.X, left_3.Y + right_3.Y);
        });
        return Optic_Map_op_HatPercent_Z1462312A(Optic_Map.Map$, Compose_Lens_op_GreaterMinusGreater_Z15C92E89(Compose_Lens.Lens, DrawModelType_SheetT_pos_)(DrawModelType_SheetT_scrollingLastMousePos_))(posDelta)(Optic_Map_op_HatPercent_Z1462312A(Optic_Map.Map$, DrawModelType_SheetT_lastMousePosForSnap_)(posDelta)(Optic_Map_op_HatPercent_Z1462312A(Optic_Map.Map$, DrawModelType_SheetT_lastMousePos_)(posDelta)(Optic_Map_op_HatPercent_Z1462312A(Optic_Map.Map$, DrawModelType_SheetT_screenScrollPos_)(posScreenDelta)(Optic_Set_op_HatEquals_Z147477F8(Optic_Set.Set$, DrawModelType_SheetT_canvasSize_)(newSize)(Optic_Map_op_HatPercent_Z1462312A(Optic_Map.Map$, DrawModelType_SheetT_screenScrollPos_)(posDelta)(moveCircuit(circuitMove, model)))))));
    }
}

function centredCircuitBox(win, model) {
    let left_1, right_1;
    const boxParas = Constants_boxParameters;
    const sBox = addBoxMargin(boxParas.BoxMarginFraction, boxParas.BoxMin, symbolWireBBUnion(model));
    const mag = magToFitBox(win, sBox);
    const newCanvasSize = max_1(max_1(((2 * win.Inset) + win.Width) / mag, win.Height / mag), max_1(Constants_defaultCanvasSize, (1 + (2 * boxParas.CanvasBorder)) * max_1(sBox.W, sBox.H)));
    let offsetToCentreCircuit;
    const left = new XYPos(newCanvasSize / 2, newCanvasSize / 2);
    const right = BoundingBox__Centre(sBox);
    offsetToCentreCircuit = (new XYPos(left.X - right.X, left.Y - right.Y));
    return {
        Box: new BoundingBox((left_1 = sBox.TopLeft, (right_1 = offsetToCentreCircuit, new XYPos(left_1.X + right_1.X, left_1.Y + right_1.Y))), sBox.W, sBox.H),
        CanvasSize: newCanvasSize,
        Offset: offsetToCentreCircuit,
    };
}

/**
 * shift circuit to middle of canvas, resizing canvas to allow enough border if needed.
 * return scroll and zoom paras to display all of circuit in middle of the given window
 */
export function fitCircuitToWindowParas(win, model) {
    const centred = centredCircuitBox(win, model);
    const modelWithMovedCircuit = moveCircuit(centred.Offset, new DrawModelType_SheetT_Model(model.Wire, model.PopupViewFunc, model.PopupDialogData, model.BoundingBoxes, model.LastValidBoundingBoxes, model.SelectedLabel, model.SelectedComponents, model.SelectedWires, model.NearbyComponents, model.HoveredWire, model.ErrorComponents, model.DragToSelectBox, model.ConnectPortsLine, model.TargetPortId, model.Action, model.ShowGrid, model.CursorType, model.LastCursorType, model.LastValidPos, model.LastValidSymbol, model.SymbolEdit, model.SnapSymbols, model.SnapSegments, model.Zoom, centred.CanvasSize, model.TmpModel, model.ScalingTmpModel, model.UndoList, model.RedoList, model.AutomaticScrolling, model.ScreenScrollPos, model.PendingZoomCenter, model.LastMousePos, model.ScalingBoxCentrePos, model.InitMouseToScalingBoxCentre, model.ScrollingLastMousePos, model.LastMousePosForSnap, model.MouseCounter, model.CtrlKeyDown, model.SpaceKeyDown, model.PrevWireSelection, model.OfferPasteArray, model.ScalingBox, model.Compiling, model.CompilationStatus, model.CompilationJob, model.DebugState, model.DebugData, model.DebugMappings, model.DebugIsConnected, model.DebugDevice));
    const paras = getWindowParasToFitBox(win, centred.Box);
    return [new DrawModelType_SheetT_Model(modelWithMovedCircuit.Wire, modelWithMovedCircuit.PopupViewFunc, modelWithMovedCircuit.PopupDialogData, modelWithMovedCircuit.BoundingBoxes, modelWithMovedCircuit.LastValidBoundingBoxes, modelWithMovedCircuit.SelectedLabel, modelWithMovedCircuit.SelectedComponents, modelWithMovedCircuit.SelectedWires, modelWithMovedCircuit.NearbyComponents, modelWithMovedCircuit.HoveredWire, modelWithMovedCircuit.ErrorComponents, modelWithMovedCircuit.DragToSelectBox, modelWithMovedCircuit.ConnectPortsLine, modelWithMovedCircuit.TargetPortId, modelWithMovedCircuit.Action, modelWithMovedCircuit.ShowGrid, modelWithMovedCircuit.CursorType, modelWithMovedCircuit.LastCursorType, modelWithMovedCircuit.LastValidPos, modelWithMovedCircuit.LastValidSymbol, modelWithMovedCircuit.SymbolEdit, modelWithMovedCircuit.SnapSymbols, modelWithMovedCircuit.SnapSegments, paras.MagToUse, modelWithMovedCircuit.CanvasSize, modelWithMovedCircuit.TmpModel, modelWithMovedCircuit.ScalingTmpModel, modelWithMovedCircuit.UndoList, modelWithMovedCircuit.RedoList, modelWithMovedCircuit.AutomaticScrolling, paras.Scroll, modelWithMovedCircuit.PendingZoomCenter, modelWithMovedCircuit.LastMousePos, modelWithMovedCircuit.ScalingBoxCentrePos, modelWithMovedCircuit.InitMouseToScalingBoxCentre, modelWithMovedCircuit.ScrollingLastMousePos, modelWithMovedCircuit.LastMousePosForSnap, modelWithMovedCircuit.MouseCounter, modelWithMovedCircuit.CtrlKeyDown, modelWithMovedCircuit.SpaceKeyDown, modelWithMovedCircuit.PrevWireSelection, modelWithMovedCircuit.OfferPasteArray, modelWithMovedCircuit.ScalingBox, modelWithMovedCircuit.Compiling, modelWithMovedCircuit.CompilationStatus, modelWithMovedCircuit.CompilationJob, modelWithMovedCircuit.DebugState, modelWithMovedCircuit.DebugData, modelWithMovedCircuit.DebugMappings, modelWithMovedCircuit.DebugIsConnected, modelWithMovedCircuit.DebugDevice), paras];
}

/**
 * Whether the sheet is still exactly where a fit to `win` would put it, and so has not been
 * scrolled, zoomed or edited since one. Undoing a fit - as unpinning the Sheet menu does - is only
 * ever right for a view the fit itself chose: once the user has moved it, it is theirs.
 * 
 * A second fit of an already fitted circuit is a no-op, since the circuit is centred on the canvas
 * already and the same box gives the same magnification, so this can ask by computing one.
 * 
 * Compared against where the canvas is actually scrolled to, not against the model's record of it:
 * a fit that asks to scroll past a canvas edge gets what the browser allows instead, and it is
 * that the user is looking at.
 */
export function isAtFittedPosition(win, model) {
    const canvas = document.getElementById("Canvas");
    if (equals(canvas, defaultOf())) {
        return false;
    }
    else {
        const paras = getWindowParasToFitBox(win, centredCircuitBox(win, model).Box);
        const asScrolled = (wanted, got, limit) => (Math.abs(min_1(limit, max_1(0, wanted)) - got) < 2);
        const fitted = ((Math.abs(paras.MagToUse - model.Zoom) < 0.001) && asScrolled(paras.Scroll.X, canvas.scrollLeft, canvas.scrollWidth - canvas.clientWidth)) && asScrolled(paras.Scroll.Y, canvas.scrollTop, canvas.scrollHeight - canvas.clientHeight);
        dbg(16, `fitted=${fitted}: zoom ${model.Zoom} vs ${paras.MagToUse}, scroll (${canvas.scrollLeft},${canvas.scrollTop}) vs (${paras.Scroll.X},${paras.Scroll.Y})`);
        return fitted;
    }
}

export function isBBoxAllVisible(model, bb) {
    let edge, z, matchValue, matchValue_1, matchValue_2, matchValue_3;
    const option_1 = getScreenEdgeCoords(model);
    if (option_1 != null) {
        return (edge = option_1, (z = model.Zoom, (matchValue = (edge.Left / z), (matchValue_1 = (edge.Right / z), (matchValue_2 = (edge.Top / z), (matchValue_3 = (edge.Bottom / z), (standardiseBox(bb), (((matchValue < bb.TopLeft.Y) && (matchValue_2 < bb.TopLeft.X)) && ((bb.TopLeft.Y + bb.H) < matchValue_3)) && ((bb.TopLeft.X + bb.W) < matchValue_1))))))));
    }
    else {
        return undefined;
    }
}

/**
 * could be made more efficient, since segments contain redundant info
 */
export function getWireBBox(wire) {
    const wire_1 = wire;
    return fold((tupledArg, seg_1) => {
        let segEnd, state, newTop, newBottom, newRight, newLeft;
        const currOrientation = tupledArg[2];
        let nextPos;
        const position = tupledArg[1];
        const length = seg_1.Length;
        nextPos = ((currOrientation === "vertical") ? (new XYPos(position.X, position.Y + length)) : (new XYPos(position.X + length, position.Y)));
        const nextOrientation = (currOrientation === "vertical") ? "horizontal" : "vertical";
        return [(segEnd = nextPos, (state = tupledArg[0], (newTop = min_1(state.TopLeft.Y, segEnd.Y), (newBottom = max_1(state.TopLeft.Y + state.H, segEnd.Y), (newRight = max_1(state.TopLeft.X + state.W, segEnd.X), (newLeft = min_1(state.TopLeft.X, segEnd.X), new BoundingBox(new XYPos(newTop, newLeft), newRight - newLeft, newBottom - newTop))))))), nextPos, nextOrientation];
    }, [new BoundingBox(wire.StartPos, 0, 0), wire_1.StartPos, wire_1.InitialOrientation], wire_1.Segments)[0];
}

export function isAllVisible(model, conns, comps) {
    const wVisible = fold((e, e_1) => (e && e_1), true, map_4((arg) => defaultArg(isBBoxAllVisible(model, arg), true), map_4(getWireBBox, concat(map_4((cid) => ofArray(toArray(tryFind(cid, model.Wire.Wires))), conns)))));
    const cVisible = fold((e_2, e_3) => (e_2 && e_3), true, map_4((bBox) => defaultArg(isBBoxAllVisible(model, bBox), false), collect((comp) => {
        let sym, patternInput, sym_1, comp_1, matchValue, vS, hS, matchValue_2, left, right;
        if (containsKey(comp, model.Wire.Symbol.Symbols)) {
            return singleton((sym = find(comp, model.Wire.Symbol.Symbols), (patternInput = ((sym_1 = sym, (comp_1 = sym_1.Component, (matchValue = defaultArg(sym_1.HScale, 1), (vS = defaultArg(sym_1.VScale, 1), (hS = matchValue, (matchValue_2 = sym_1.STransform.Rotation, (matchValue_2.tag === 2) ? [comp_1.H * vS, comp_1.W * hS] : ((matchValue_2.tag === 1) ? [comp_1.W * hS, comp_1.H * vS] : ((matchValue_2.tag === 3) ? [comp_1.W * hS, comp_1.H * vS] : [comp_1.H * vS, comp_1.W * hS]))))))))), equals(sym.Annotation, DrawModelType_SymbolT_Annotation.ScaleButton) ? (new BoundingBox((left = sym.Pos, (right = (new XYPos(9, 9)), new XYPos(left.X - right.X, left.Y - right.Y))), 17, 17)) : (new BoundingBox(sym.Pos, patternInput[1], patternInput[0])))));
        }
        else {
            return empty();
        }
    }, comps)));
    if (wVisible) {
        return cVisible;
    }
    else {
        return false;
    }
}

/**
 * Finds all components that touch a bounding box (which is usually the drag-to-select box)
 */
export function findIntersectingComponents(model, box1) {
    return map_4((tuple) => tuple[0], toList_1(filter((id, boundingBox) => {
        if (equals(find(id, model.Wire.Symbol.Symbols).Annotation, undefined)) {
            return boxesIntersect(boundingBox, box1);
        }
        else {
            return false;
        }
    }, model.BoundingBoxes)));
}

export function posAdd(pos, a, b) {
    return new XYPos(pos.X + a, pos.Y + b);
}

/**
 * Finds all components (that are stored in the Sheet model) near pos
 */
export function findNearbyComponentsOld(model, pos, range) {
    return collect((_arg) => {
        if (_arg != null) {
            return singleton(_arg);
        }
        else {
            return empty();
        }
    }, map_4((arg) => {
        let pos_1;
        const x = arg;
        pos_1 = posAdd(pos, x[0], x[1]);
        return tryFindKey((k, box) => insideBox(pos_1, box), model.BoundingBoxes);
    }, allPairs(toList_2(rangeDouble(-range, 10, range)), toList_2(rangeDouble(-range, 10, range)))));
}

/**
 * Finds all components (that are stored in the Sheet model) near pos
 * Optimised a little for space
 */
export function findNearbyComponents(model, pos, range) {
    let closeComps = empty();
    const enumerator = getEnumerator(rangeDouble(10 - range, 10, 10 + range));
    try {
        while (enumerator["System.Collections.IEnumerator.MoveNext"]()) {
            const x = enumerator["System.Collections.Generic.IEnumerator`1.get_Current"]();
            const enumerator_1 = getEnumerator(rangeDouble(10 - range, 10, 10 + range));
            try {
                while (enumerator_1["System.Collections.IEnumerator.MoveNext"]()) {
                    let _arg;
                    const pos_1 = new XYPos(x + pos.X, enumerator_1["System.Collections.Generic.IEnumerator`1.get_Current"]() + pos.Y);
                    _arg = tryFindKey((k, box) => insideBox(pos_1, box), model.BoundingBoxes);
                    if (_arg == null) {
                    }
                    else {
                        const cId = _arg;
                        closeComps = cons(cId, closeComps);
                    }
                }
            }
            finally {
                disposeSafe(enumerator_1);
            }
        }
    }
    finally {
        disposeSafe(enumerator);
    }
    return closeComps;
}

/**
 * Checks if pos is inside any of the ports in portList
 */
export function mouseOnPort(portList, pos, margin) {
    const matchValue = tryFind_1((tupledArg) => {
        let arg0__5, arg0__1, arg0__3;
        const pos_1 = pos;
        const portLocation = tupledArg[1];
        return ((arg0__5 = (((arg0__1 = (pos_1.X - portLocation.X), Math.pow(arg0__1, 2))) + ((arg0__3 = (pos_1.Y - portLocation.Y), Math.pow(arg0__3, 2)))), Math.pow(arg0__5, 0.5))) <= (5 + margin);
    }, portList);
    if (matchValue == null) {
        return undefined;
    }
    else {
        return [matchValue[0], matchValue[1]];
    }
}

/**
 * Returns the ports of all model.NearbyComponents
 */
export function findNearbyPorts(model) {
    const patternInput = getPortLocations(model.Wire.Symbol, model.NearbyComponents);
    return [toList_1(patternInput[0]), toList_1(patternInput[1])];
}

/**
 * Returns what is located at pos.
 * Priority Order: InputPort -> OutputPort -> Label -> Wire -> Component -> Canvas
 */
export function mouseOn(model, pos) {
    const patternInput = findNearbyPorts(model);
    const matchValue = mouseOnPort(patternInput[0], pos, 2.5);
    if (matchValue == null) {
        const matchValue_1 = mouseOnPort(patternInput[1], pos, 2.5);
        if (matchValue_1 == null) {
            const matchValue_3 = tryPick((sId, sym) => {
                if (sym.Component.Type.tag === 26) {
                    let _arg_1;
                    const corners = translatePoints(sym.Pos, getCustomSymCorners(sym));
                    if (!equalsWith(equals, corners, defaultOf()) && (corners.length === 0)) {
                        _arg_1 = undefined;
                    }
                    else {
                        const _arg = tryFindIndex((c) => {
                            const pos_1_1 = pos;
                            const circleLocation = c;
                            return Math.pow(Math.pow(pos_1_1.X - circleLocation.X, 2) + Math.pow(pos_1_1.Y - circleLocation.Y, 2), 0.5) <= (5 + 2.5);
                        }, corners);
                        if (_arg == null) {
                            _arg_1 = undefined;
                        }
                        else {
                            const idx = _arg | 0;
                            _arg_1 = [item((idx + 2) % 4, corners), idx];
                        }
                    }
                    if (_arg_1 != null) {
                        return [sym, _arg_1[0], _arg_1[1]];
                    }
                    else {
                        return undefined;
                    }
                }
                else {
                    return undefined;
                }
            }, Optic_Get_op_HatDot_Z146BA564(Optic_Get.Get, DrawModelType_SheetT_symbols_)(model));
            if (matchValue_3 == null) {
                const matchValue_4 = tryPick((sId_1, sym_2) => {
                    if (insideBox(pos, sym_2.LabelBoundingBox)) {
                        return sym_2;
                    }
                    else {
                        return undefined;
                    }
                }, Optic_Get_op_HatDot_Z146BA564(Optic_Get.Get, DrawModelType_SheetT_symbols_)(model));
                if (matchValue_4 == null) {
                    const matchValue_5 = getClickedWire(model.Wire, pos, Constants_wireBoundingBoxSize / model.Zoom);
                    if (matchValue_5 == null) {
                        const matchValue_6 = tryFindKey((k, box) => insideBox(pos, box), model.BoundingBoxes);
                        if (matchValue_6 == null) {
                            return DrawModelType_SheetT_MouseOn.Canvas;
                        }
                        else {
                            return new DrawModelType_SheetT_MouseOn(/* Component */ 3, [matchValue_6]);
                        }
                    }
                    else {
                        return new DrawModelType_SheetT_MouseOn(/* Connection */ 4, [matchValue_5]);
                    }
                }
                else {
                    return new DrawModelType_SheetT_MouseOn(/* Label */ 0, [matchValue_4.Id]);
                }
            }
            else {
                return new DrawModelType_SheetT_MouseOn(/* ComponentCorner */ 5, [matchValue_3[0].Id, matchValue_3[1], matchValue_3[2]]);
            }
        }
        else {
            return new DrawModelType_SheetT_MouseOn(/* OutputPort */ 2, [matchValue_1[0], matchValue_1[1]]);
        }
    }
    else {
        return new DrawModelType_SheetT_MouseOn(/* InputPort */ 1, [matchValue[0], matchValue[1]]);
    }
}

export function notIntersectingComponents(model, box1, inputId) {
    return isEmpty_1(filter((sId, boundingBox) => {
        if (boxesIntersect(boundingBox, box1)) {
            return !equals(inputId, sId);
        }
        else {
            return false;
        }
    }, model.BoundingBoxes));
}

export function notIntersectingSelectedComponents(model, box1, inputId) {
    return isEmpty_1(filter((sId_1, boundingBox) => {
        if (boxesIntersect(boundingBox, box1)) {
            return !equals(inputId, sId_1);
        }
        else {
            return false;
        }
    }, filter((sId, _arg) => contains(sId, model.SelectedComponents, {
        Equals: equals,
        GetHashCode: (x) => (safeHash(x) | 0),
    }), model.BoundingBoxes)));
}

